module.exports = __webpack_public_path__ + "img/altamidia.34fe9015.png";